import { render, staticRenderFns } from "./NewChatComposer.vue?vue&type=template&id=04839edd"
import script from "./NewChatComposer.vue?vue&type=script&lang=js"
export * from "./NewChatComposer.vue?vue&type=script&lang=js"
import style0 from "./NewChatComposer.vue?vue&type=style&index=0&id=04839edd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports